import { ISchool, IVideo } from "./models";

//#region Test Video Sets
const testVideosSet1: IVideo[] = [
  { id: 1, thumbnailUrl: "http://i3.ytimg.com/vi/sKtloBAuP74/hqdefault.jpg", videoUrl: "https://www.youtube.com/watch?v=sKtloBAuP74" },
];

const testVideosSet2: IVideo[] = [
  { id: 1, thumbnailUrl: "http://i3.ytimg.com/vi/sKtloBAuP74/hqdefault.jpg", videoUrl: "https://www.youtube.com/watch?v=sKtloBAuP74" },
  { id: 2, thumbnailUrl: "http://i3.ytimg.com/vi/sKtloBAuP74/hqdefault.jpg", videoUrl: "https://www.youtube.com/watch?v=sKtloBAuP74" },
  { id: 6, thumbnailUrl: "http://i3.ytimg.com/vi/sKtloBAuP74/hqdefault.jpg", videoUrl: "https://www.youtube.com/watch?v=sKtloBAuP74" },
];

const testVideosSet3: IVideo[] = [
  { id: 1, thumbnailUrl: "http://i3.ytimg.com/vi/sKtloBAuP74/hqdefault.jpg", videoUrl: "https://www.youtube.com/watch?v=sKtloBAuP74" },
  { id: 2, thumbnailUrl: "http://i3.ytimg.com/vi/sKtloBAuP74/hqdefault.jpg", videoUrl: "https://www.youtube.com/watch?v=sKtloBAuP74" },
  { id: 3, thumbnailUrl: "http://i3.ytimg.com/vi/sKtloBAuP74/hqdefault.jpg", videoUrl: "https://www.youtube.com/watch?v=sKtloBAuP74" },
  { id: 4, thumbnailUrl: "http://i3.ytimg.com/vi/sKtloBAuP74/hqdefault.jpg", videoUrl: "https://www.youtube.com/watch?v=sKtloBAuP74" },
  { id: 5, thumbnailUrl: "http://i3.ytimg.com/vi/sKtloBAuP74/hqdefault.jpg", videoUrl: "https://www.youtube.com/watch?v=sKtloBAuP74" },
  { id: 6, thumbnailUrl: "http://i3.ytimg.com/vi/sKtloBAuP74/hqdefault.jpg", videoUrl: "https://www.youtube.com/watch?v=sKtloBAuP74" },
];
//#endregion Test Video Sets

//#region Compton school
export const ComptonSchool: ISchool = {
  id: 1,
  name: "Compton",
  description: "Some long text description here. Maybe html...",  // TODO: Ask if School Description is html or plain text.
  defaultCourseId: 73,
  courses: [
    {
      id: 10001,
      name: "Math 10A",
      units: 2,
      part: "I",
      additionalInfo: "Basic Arithmetic Skills",
    },

    {
      id: 10002,
      name: "Math 10B",
      units: 2,
      part: "II",
      additionalInfo: "Basic Arithmetic Skills",
    },

    {
      id: 12,
      name: "Math 12",
      units: 4,
      additionalInfo: "Basic Arithmetic Skills",
    },

    {
      id: 25,
      name: "Math 25",
      units: 2,
      additionalInfo: "Pre-Algebra Review",
    },
    {
      id: 23,
      name: "Math 23",
      units: 2,
      additionalInfo: "Pre Algebra",
      videos: testVideosSet2
    },

    {
      id: 40,
      name: "Math 40",
      units: 4,
      additionalInfo: "Elementary Algebra",
      videos: testVideosSet2
    },
    {
      id: 33,
      name: "Math 33",
      units: 3,
      part: "I",
      additionalInfo: "Extended Elementary Algebra",
    },

    {
      id: 43,
      name: "Math 43",
      units: 3,
      part: "II",
      additionalInfo: "Extender Elementary Algebra",
    },

    {
      id: 80,
      name: "Math 80",
      units: 5,
      additionalInfo: "Intermediate Algebra for STEM"
    },
    {
      id: 73,
      name: "Math 73",
      units: 5,
      additionalInfo: "Intermediate Algebra for General Education",
      videos: [

      ]
    },
    {
      id: 60,
      name: "Math 60",
      units: 4,
      additionalInfo: "Elementary Geometry",
      videos: testVideosSet3
    },

    {
      id: 170,
      name: "Math 170 *",
      units: 3,
      additionalInfo: "Trigonometry"
    },
    {
      id: 180,
      name: "Math 180 *",
      units: 5,
      additionalInfo: "Pre-Calculus",
    },
    {
      id: 130,
      name: "Math 130 **",
      units: 3,
      additionalInfo: "College Algebra",
    },
    {
      id: 120,
      name: "Math 120 *",
      units: 3,
      additionalInfo: "Nature of Math"
    },
    {
      id: 140,
      name: "Math 140 **",
      units: 4,
      additionalInfo: "Finite Math"
    },
    {
      id: 150,
      name: "Math 150 **",
      units: 4,
      additionalInfo: "Elementary Probability and Statistics",
      videos: testVideosSet3
    },

    {
      id: 160,
      name: "Math 160 **",
      units: 4,
      additionalInfo: "Calculus for the Biological, Management, and Social Sciences I",
    },
    {
      id: 161,
      name: "Math 161 **",
      units: 4,
      additionalInfo: "Calculus for the Biological, Management, and Social Sciences II",
      videos: testVideosSet1
    },
    {
      id: 190,
      name: "Math 190 **",
      units: 5,
      additionalInfo: "Single Variable Calculus I",
    },
    {
      id: 191,
      name: "Math 191 **",
      units: 4,
      additionalInfo: "Single Variable Calculus II",
    },
    {
      id: 220,
      name: "Math 220 **",
      units: 4,
      additionalInfo: "Multi-Variable Calculus",
    }
  ],
  coursesLinks: [
    { parentId: 10001, childId: 10002 }, // 10A -> 10B
    { parentId: 10002, childId: 23 }, // 10B -> 23
    { parentId: 10002, childId: 25 }, // 10B -> 25
    { parentId: 12, childId: 23 }, // 10B -> 25
    { parentId: 12, childId: 25 }, // 10B -> 25
    { parentId: 25, childId: 40 },
    { parentId: 25, childId: 33 },
    { parentId: 23, childId: 40 },
    { parentId: 23, childId: 33 },
    { parentId: 40, childId: 73 },
    { parentId: 33, childId: 43 },
    { parentId: 43, childId: 80 },
    { parentId: 43, childId: 73 },
    { parentId: 43, childId: 60 },
    { parentId: 80, childId: 170 },
    { parentId: 80, childId: 120 },
    { parentId: 80, childId: 140 },
    { parentId: 80, childId: 130 },
    { parentId: 80, childId: 150 },
    { parentId: 73, childId: 150 },
    { parentId: 73, childId: 120 },
    { parentId: 73, childId: 140 },
    { parentId: 73, childId: 130 },
    { parentId: 73, childId: 150 },
    { parentId: 170, childId: 180 },
    { parentId: 130, childId: 160 },
    { parentId: 180, childId: 160 },
    { parentId: 180, childId: 190 },
    { parentId: 160, childId: 161 },
    { parentId: 190, childId: 191 },
    { parentId: 191, childId: 220 },
  ],
};
//#endregion Compton school

export const Schools: ISchool[] = [ComptonSchool];
